import React from "react";
import { SelectedChips, SelectedChipsProps } from "src/commons";

export const GenericChipFilter = <T,>(props: SelectedChipsProps<T>) => <SelectedChips<T> {...props} />;
